import axios from "axios";
const BASE_URL = window.location.hostname === "localhost" ? "http://localhost:8000" : "https://app.jedichatai.com";
export const api = axios.create({
  baseURL: BASE_URL,
  timeout: 15000,
});
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("jedichatai_token");
  if (token) config.headers.Authorization = "Bearer " + token;
  return config;
});
// On 401 - clear token and redirect to login
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("jedichatai_token");
      window.location.reload();
    }
    return Promise.reject(error);
  }
);
export async function getToken() {
  const token = localStorage.getItem("jedichatai_token");
  if (token) return token;
  return null;
}
export async function getConversations() {
  const res = await api.get("/api/v1/conversations");
  return res.data;
}
export async function approveReply(contactId: string, message: string, to: string) {
  const res = await api.post("/api/v1/conversations/approve", { contactId, message, to });
  return res.data;
}
export async function dismissReply(contactId: string) {
  const res = await api.delete("/api/v1/conversations/" + contactId);
  return res.data;
}
export async function getAutoRespond() {
  const res = await api.get("/api/v1/settings/auto-respond");
  return res.data;
}
export async function setGlobalAutoRespond(enabled: boolean) {
  const res = await api.post("/api/v1/settings/auto-respond", { global: enabled });
  return res.data;
}
export async function setContactAutoRespond(contactId: string, enabled: boolean) {
  const res = await api.post("/api/v1/settings/auto-respond", { contactId, enabled });
  return res.data;
}
export async function getTemplates() {
  const res = await api.get("/api/v1/templates");
  return res.data;
}
export async function createTemplate(payload: {title: string; body: string; category: string; icon: string}) {
  const res = await api.post("/api/v1/templates", payload);
  return res.data;
}
export async function updateTemplate(id: number, payload: any) {
  const res = await api.put("/api/v1/templates/" + id, payload);
  return res.data;
}
export async function deleteTemplate(id: number) {
  const res = await api.delete("/api/v1/templates/" + id);
  return res.data;
}
export async function useTemplate(id: number) {
  const res = await api.post("/api/v1/templates/" + id + "/use", {});
  return res.data;
}
export async function getGroups() {
  const res = await api.get("/api/v1/groups");
  return res.data;
}
export async function createGroup(payload: any) {
  const res = await api.post("/api/v1/groups", payload);
  return res.data;
}
export async function updateGroup(id: number, payload: any) {
  const res = await api.put("/api/v1/groups/" + id, payload);
  return res.data;
}
export async function deleteGroup(id: number) {
  const res = await api.delete("/api/v1/groups/" + id);
  return res.data;
}
export async function listGroupMembers(id: number) {
  const res = await api.get("/api/v1/groups/" + id + "/members");
  return res.data;
}
export async function addGroupMember(id: number, payload: {contact_id: string; contact_name?: string}) {
  const res = await api.post("/api/v1/groups/" + id + "/members", payload);
  return res.data;
}
export async function removeGroupMember(groupId: number, contactId: string) {
  const res = await api.delete("/api/v1/groups/" + groupId + "/members/" + encodeURIComponent(contactId));
  return res.data;
}
export async function evaluateGroup(id: number) {
  const res = await api.post("/api/v1/groups/" + id + "/evaluate", {});
  return res.data;
}
export async function listContacts() {
  const res = await api.get("/api/v1/contacts");
  return res.data;
}

export async function getAway() {
  const res = await api.get("/api/v1/settings/away");
  return res.data;
}
export async function setAway(enabled: boolean, message: string, target: string) {
  const res = await api.post("/api/v1/settings/away", { enabled, message, target });
  return res.data;
}
